import React from 'react'
import WebhookBoletoListPageContainer from './WebhookBoletoListPageContainer'

export class WebhookBoletoListPage extends React.Component {
  render() {
    return <WebhookBoletoListPageContainer {...this.props} />
  }
}
